import popupCloseIcon from "../../assests/page/popup-close-icon.svg";
import backIcon from "../../assests/page/chevron-left.svg";
import selectBankCircle from "../../assests/page/select-bank-circle.svg";
import selectBankClicked from "../../assests/page/select-bank-clicked.svg";
import React, { useState } from "react";
import LoadingPopup from "./loading";
import Avatar from "react-avatar";
import useUserStore from "../../store/userSlice";
import { useNavigate } from "react-router-dom";
import { LinkBankOption } from "./linkbankOptions";
import GeneralPopupBackground from ".";
import { extractNumberWithCommas } from "../../utils/helpers/utils";

const SelectBank = (props) => {
  const [selectedBank, setSelectedBank] = useState(
    props.selectedBank || {
      name: "",
      acct: "",
      logo: "",
    },
  );
  const [selectedBankIdx, setSelectedBankIdx] = useState("");
  const [showAction, setShowAction] = useState(props.showAction || false);
  const [showCustomPopup, setShowCustomPopup] = useState(false);
  const [customPopupContent, setCustomPopupContent] = useState(null);
  const [customPopupPosition, setCustomPopupPosition] = useState("");

  const navigate = useNavigate();

  const { userFirstName, userEmail } = useUserStore();

  const handleButtonDisplay = () => {
    const button = document.getElementById("select-bank-popup-button");
    if (button) {
      button.className = "startup-button-active";
    }
  };

  return (
    <React.Fragment>
      {showCustomPopup && (
        <GeneralPopupBackground
          popupContent={customPopupContent}
          popupContentPosition={
            customPopupPosition !== "" ? customPopupPosition : "center"
          }
        />
      )}
      <div className="add-funds-popup">
        <div
          style={{ overflowX: "hidden", overflowY: "auto" }}
          className="add-funds-content"
        >
          <div className="add-funds-content-header">
            <div className="add-funds-content-header-text-container">
              {!showAction && (
                <>
                  <img
                    className="profile-popup-icon"
                    onClick={() => {
                      if (props.backClickPopup) {
                        props.setPopupContentPosition("flex-end");
                        props.setPopupContent(props.backClickPopup);
                      } else if (props.backClickUrl) {
                        navigate(props.backClickUrl);
                      }
                    }}
                    alt="Back Icon"
                    src={backIcon}
                  />
                  {props.action === "link-bank" && (
                    <p className="add-funds-content-header-text">Select Bank</p>
                  )}
                  {props.action === "custody-select-bank" && (
                    <p className="add-funds-content-header-text">
                      Select Custody Bank
                    </p>
                  )}
                  {props.action === "pre-add-funds" && (
                    <p className="add-funds-content-header-text">Select Bank</p>
                  )}
                  {props.action !== "link-bank" &&
                    props.action !== "pre-add-funds" &&
                    props.action !== "custody-select-bank" && (
                      <p className="add-funds-content-header-text">
                        Select Bank Account
                      </p>
                    )}
                </>
              )}
              {showAction && props.action?.includes("withdraw") && (
                <>
                  <p
                    style={{ maxWidth: "90%", wordWrap: "break-word" }}
                    className="add-funds-content-header-text"
                  >
                    Money will be credited to selected account,{" "}
                    {selectedBank?.name}
                  </p>
                  <img
                    onClick={() => {
                      props.setShowPopup(false);
                      props.setPopupContent(null);
                      props.setPopupContentPosition("center");
                      if (props.setFavouriteClicked) {
                        props.setFavouriteClicked(false);
                      }
                    }}
                    className="add-funds-popup-close-icon"
                    alt="Close Icon"
                    src={popupCloseIcon}
                  />
                </>
              )}
            </div>
            {!showAction && (
              <img
                onClick={() => {
                  props.setShowPopup(false);
                  props.setPopupContent(null);
                  props.setPopupContentPosition("center");
                  if (props.setFavouriteClicked) {
                    props.setFavouriteClicked(false);
                  }
                }}
                className="add-funds-popup-close-icon"
                alt="Close Icon"
                src={popupCloseIcon}
              />
            )}
          </div>

          {showAction && props.action?.includes("withdraw") && (
            <React.Fragment>
              <div className="select-bank-withdraw-header">
                <div className="select-bank-popup-body-content-icon">
                  <img
                    src={selectedBank?.logo || selectedBank?.icon}
                    alt="Bank Logo"
                  />
                </div>

                <div className="select-bank-withdraw-header-text-container">
                  <p className="select-bank-withdraw-header-text">
                    {selectedBank?.name}
                  </p>
                  <p className="select-bank-withdraw-header-label">
                    A/c No : {selectedBank?.acct || selectedBank?.bankAccountId}
                  </p>
                </div>
              </div>

              <div
                style={{ marginTop: "10px" }}
                className="borrow-popup-content-body-main-second-custom-third-footer"
              >
                <div className="borrow-popup-content-body-main-second-custom-third-footer-body">
                  <p className="borrow-popup-content-body-main-second-custom-content-header-second-title">
                    Withdrawal Details
                  </p>
                  <p
                    style={{ color: "#5B5D6E" }}
                    className="borrow-popup-content-body-main-second-custom-content-header-label"
                  >
                    Currency: <b>{props.selectedCurrency?.currencySymbol}</b>
                  </p>
                </div>
                <p
                  style={{
                    maxWidth: "55%",
                    wordWrap: "break-word",
                  }}
                  className="borrow-popup-content-body-main-second-custom-third-footer-text"
                >
                  {props.selectedCurrency?.officialCurrencySymbol}{" "}
                  {Number(props.amount) > 0
                    ? extractNumberWithCommas(props.amount)?.fmtNumber
                    : "0.00"}
                </p>
              </div>
            </React.Fragment>
          )}

          {!showAction && props.action?.includes("withdraw") && (
            <div className="select-bank-popup">
              <div className="select-bank-popup-container">
                <div className="select-bank-popup-body">
                  <div className="select-bank-popup-body-container">
                    {props.bankList?.length > 0 &&
                      props.bankList?.map((bnk, idx) => (
                        <React.Fragment>
                          {props.action === "card-withdraw" && (
                            <div
                              onClick={() => {
                                setSelectedBankIdx(idx);
                                setSelectedBank({
                                  name: bnk?.name,
                                  id: bnk?.id,
                                  logo: bnk?.logo || bnk?.icon,
                                  acct: bnk?.acct,
                                });

                                handleButtonDisplay();
                              }}
                              className="select-bank-popup-body-content"
                            >
                              <div className="select-bank-popup-body-content-container">
                                <div className="select-bank-popup-body-content-icon">
                                  <img
                                    src={bnk?.logo || bnk?.icon}
                                    alt="Bank Logo"
                                  />
                                </div>

                                <div className="select-bank-popup-body-content-main">
                                  <div className="select-bank-popup-body-content-text-container">
                                    <p className="select-bank-popup-body-content-text">
                                      {bnk?.name}
                                    </p>
                                    <p className="select-bank-popup-body-content-label">
                                      {bnk?.acct}
                                    </p>
                                  </div>
                                  {selectedBankIdx !== idx && (
                                    <img
                                      src={selectBankCircle}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                  {selectedBankIdx === idx && (
                                    <img
                                      src={selectBankClicked}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          )}

                          {props.action === "bank-withdraw" && (
                            <>
                              {bnk?.custodyCurrencyType === "moneyhub" && (
                                <div
                                  onClick={() => {
                                    setSelectedBankIdx(idx);
                                    setSelectedBank({
                                      name: bnk?.companyName,
                                      id: bnk?.providerId,
                                      bankAccountId: bnk?.id,
                                      logo: bnk?.logo || bnk?.icon,
                                      bankType: bnk?.type,
                                      ...bnk,
                                    });
                                    handleButtonDisplay();
                                  }}
                                  className="select-bank-popup-body-content"
                                >
                                  <div className="select-bank-popup-body-content-container">
                                    <div className="select-bank-popup-body-content-icon">
                                      <>
                                        {bnk?.iconUrl && (
                                          <img
                                            src={bnk.iconUrl}
                                            alt="Bank Icon"
                                          />
                                        )}
                                        {!bnk?.iconUrl && (
                                          <Avatar name={bnk.companyName} />
                                        )}
                                      </>
                                    </div>

                                    <div className="select-bank-popup-body-content-main">
                                      <div className="select-bank-popup-body-content-text-container">
                                        <p className="select-bank-popup-body-content-text">
                                          {bnk?.productName}
                                        </p>
                                        <p className="select-bank-popup-body-content-label">
                                          {bnk?.accountName}
                                        </p>
                                      </div>
                                      {selectedBankIdx !== idx && (
                                        <img
                                          src={selectBankCircle}
                                          alt="Checkbox Icon"
                                        />
                                      )}
                                      {selectedBankIdx === idx && (
                                        <img
                                          src={selectBankClicked}
                                          alt="Checkbox Icon"
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                              {bnk?.custodyCurrencyType === "blink" && (
                                <div
                                  onClick={() => {
                                    setSelectedBankIdx(idx);
                                    setSelectedBank({
                                      bankName: bnk?.accountOwner,
                                      bankAccount: bnk?.account,
                                      bankAccountId: bnk?.account,
                                      id: bnk?.providerId,
                                      logo: bnk?.iconUrl,
                                      ...bnk,
                                    });
                                    handleButtonDisplay();
                                  }}
                                  className="select-bank-popup-body-content"
                                >
                                  <div className="select-bank-popup-body-content-container">
                                    <div className="select-bank-popup-body-content-icon">
                                      <>
                                        {bnk?.iconUrl && (
                                          <img
                                            src={bnk.iconUrl}
                                            alt="Bank Icon"
                                          />
                                        )}
                                        {!bnk?.iconUrl && (
                                          <Avatar name={bnk.accountOwner} />
                                        )}
                                      </>
                                    </div>

                                    <div className="select-bank-popup-body-content-main">
                                      <div className="select-bank-popup-body-content-text-container">
                                        <p className="select-bank-popup-body-content-text">
                                          {bnk.accountOwner}
                                        </p>
                                        <p className="select-bank-popup-body-content-label">
                                          {bnk.account?.type}-
                                          {bnk.account?.identification}
                                        </p>
                                      </div>
                                      {selectedBankIdx !== idx && (
                                        <img
                                          src={selectBankCircle}
                                          alt="Checkbox Icon"
                                        />
                                      )}
                                      {selectedBankIdx === idx && (
                                        <img
                                          src={selectBankClicked}
                                          alt="Checkbox Icon"
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </React.Fragment>
                      ))}

                    {props?.bankList?.length === 0 && (
                      <p>
                        You have no active linked{" "}
                        {props.action === "card-withdraw" ? "card" : "bank"}{" "}
                        account(s). Click Link Bank / Card to link valid{" "}
                        {props.action === "card-withdraw" ? "card" : "bank"}{" "}
                        account(s)
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {!showAction && props.action === "link-bank" && (
            <div className="select-bank-popup">
              <div className="select-bank-popup-container">
                <div className="select-bank-popup-body">
                  <div className="select-bank-popup-body-container">
                    {props?.bankList?.length > 0 &&
                      props.bankList?.map((bnk, idx) => (
                        <div
                          onClick={() => {
                            setSelectedBankIdx(idx);
                            setSelectedBank({
                              name: bnk?.companyName || bnk?.tradeName,
                              id: bnk?.providerId || bnk?.id,
                              logo: bnk?.logo || bnk?.icon || bnk?.avatar,
                              isBr: bnk?.ispb?.length > 0,
                            });
                            handleButtonDisplay();
                          }}
                          className="select-bank-popup-body-content"
                        >
                          <div className="select-bank-popup-body-content-container">
                            <div className="select-bank-popup-body-content-icon">
                              <img
                                src={bnk?.logo || bnk?.icon || bnk?.avatar}
                                alt="Bank Logo"
                              />
                            </div>

                            <div className="select-bank-popup-body-content-main">
                              <div className="select-bank-popup-body-content-text-container">
                                <p className="select-bank-popup-body-content-text">
                                  {bnk?.companyName || bnk?.tradeName}
                                </p>

                                {bnk?.productName?.length > 0 && (
                                  <p className="select-bank-popup-body-content-label">
                                    {bnk?.productName?.startsWith(
                                      "Product Name",
                                    )
                                      ? bnk?.companyNameAbbreviation
                                      : bnk?.productName}
                                  </p>
                                )}
                                {bnk?.ispb?.length > 0 && (
                                  <p className="select-bank-popup-body-content-label">
                                    ISPB: {bnk?.ispb}
                                  </p>
                                )}
                              </div>
                              {selectedBankIdx !== idx && (
                                <img
                                  src={selectBankCircle}
                                  alt="Checkbox Icon"
                                />
                              )}
                              {selectedBankIdx === idx && (
                                <img
                                  src={selectBankClicked}
                                  alt="Checkbox Icon"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {!showAction && props.action === "custody-select-bank" && (
            <div className="select-bank-popup">
              <div className="select-bank-popup-container">
                <div className="select-bank-popup-body">
                  <div className="select-bank-popup-body-container">
                    {props?.bankList?.length > 0 &&
                      props.bankList?.map((bnk, idx) => (
                        <div
                          onClick={() => {
                            setSelectedBankIdx(idx);
                            setSelectedBank({
                              name: bnk?.companyName,
                              id: bnk?.providerId,
                              logo: bnk?.logo || bnk?.icon,
                            });
                            handleButtonDisplay();
                          }}
                          className="select-bank-popup-body-content"
                        >
                          <div className="select-bank-popup-body-content-container">
                            <div className="select-bank-popup-body-content-icon">
                              <img
                                src={bnk?.logo || bnk?.icon}
                                alt="Bank Logo"
                              />
                            </div>

                            <div className="select-bank-popup-body-content-main">
                              <div className="select-bank-popup-body-content-text-container">
                                <p className="select-bank-popup-body-content-text">
                                  {bnk?.companyName}
                                </p>
                                <p className="select-bank-popup-body-content-label">
                                  {bnk?.productName?.startsWith("Product Name")
                                    ? bnk?.companyNameAbbreviation
                                    : bnk?.productName}
                                </p>
                              </div>
                              {selectedBankIdx !== idx && (
                                <img
                                  src={selectBankCircle}
                                  alt="Checkbox Icon"
                                />
                              )}
                              {selectedBankIdx === idx && (
                                <img
                                  src={selectBankClicked}
                                  alt="Checkbox Icon"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {!showAction && props.action === "add-funds" && (
            <div className="select-bank-popup">
              <div className="select-bank-popup-container">
                <div className="select-bank-popup-body">
                  <div className="select-bank-popup-body-container">
                    {props?.bankList?.length > 0 &&
                      props.bankList?.map((bnk, idx) => (
                        <>
                          {bnk?.custodyCurrencyType === "moneyhub" && (
                            <div
                              onClick={() => {
                                setSelectedBankIdx(idx);
                                setSelectedBank({
                                  name: bnk?.companyName,
                                  id: bnk?.providerId,
                                  bankAccountId: bnk?.id,
                                  logo: bnk?.logo || bnk?.icon,
                                  bankType: bnk?.type,
                                  ...bnk,
                                });
                                handleButtonDisplay();
                              }}
                              className="select-bank-popup-body-content"
                            >
                              <div className="select-bank-popup-body-content-container">
                                <div className="select-bank-popup-body-content-icon">
                                  <>
                                    {bnk?.iconUrl && (
                                      <img src={bnk.iconUrl} alt="Bank Icon" />
                                    )}
                                    {!bnk?.iconUrl && (
                                      <Avatar name={bnk.companyName} />
                                    )}
                                  </>
                                </div>

                                <div className="select-bank-popup-body-content-main">
                                  <div className="select-bank-popup-body-content-text-container">
                                    <p className="select-bank-popup-body-content-text">
                                      {bnk?.productName}
                                    </p>
                                    <p className="select-bank-popup-body-content-label">
                                      {bnk?.accountName}
                                    </p>
                                  </div>
                                  {selectedBankIdx !== idx && (
                                    <img
                                      src={selectBankCircle}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                  {selectedBankIdx === idx && (
                                    <img
                                      src={selectBankClicked}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                          {bnk?.custodyCurrencyType === "blink" && (
                            <div
                              onClick={() => {
                                setSelectedBankIdx(idx);
                                setSelectedBank({
                                  bankName: bnk?.accountOwner,
                                  bankAccount: bnk?.account,
                                  id: bnk?.providerId,
                                  logo: bnk?.iconUrl,
                                  ...bnk,
                                });
                                handleButtonDisplay();
                              }}
                              className="select-bank-popup-body-content"
                            >
                              <div className="select-bank-popup-body-content-container">
                                <div className="select-bank-popup-body-content-icon">
                                  <>
                                    {bnk?.iconUrl && (
                                      <img src={bnk.iconUrl} alt="Bank Icon" />
                                    )}
                                    {!bnk?.iconUrl && (
                                      <Avatar name={bnk.accountOwner} />
                                    )}
                                  </>
                                </div>

                                <div className="select-bank-popup-body-content-main">
                                  <div className="select-bank-popup-body-content-text-container">
                                    <p className="select-bank-popup-body-content-text">
                                      {bnk.accountOwner}
                                    </p>
                                    <p className="select-bank-popup-body-content-label">
                                      {bnk.account?.type}-
                                      {bnk.account?.identification}
                                    </p>
                                  </div>
                                  {selectedBankIdx !== idx && (
                                    <img
                                      src={selectBankCircle}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                  {selectedBankIdx === idx && (
                                    <img
                                      src={selectBankClicked}
                                      alt="Checkbox Icon"
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ))}

                    {props?.bankList?.length === 0 && (
                      <p>
                        You have no active linked bank account(s). Click Link
                        Bank / Card to link valid bank account(s)
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {!showAction && props.action === "pre-add-funds" && (
            <div className="select-bank-popup">
              <div className="select-bank-popup-container">
                <div className="select-bank-popup-body">
                  <div className="select-bank-popup-body-container">
                    {props?.bankList?.length > 0 &&
                      props.bankList?.map((bnk, idx) => (
                        <div
                          onClick={() => {
                            setSelectedBankIdx(idx);
                            setSelectedBank({
                              name: bnk?.companyName,
                              id: bnk?.providerId,
                              logo: bnk?.logo || bnk?.icon,
                            });
                            handleButtonDisplay();
                          }}
                          className="select-bank-popup-body-content"
                        >
                          <div className="select-bank-popup-body-content-container">
                            <div className="select-bank-popup-body-content-icon">
                              <img
                                src={bnk?.logo || bnk?.icon}
                                alt="Bank Logo"
                              />
                            </div>

                            <div className="select-bank-popup-body-content-main">
                              <div className="select-bank-popup-body-content-text-container">
                                <p className="select-bank-popup-body-content-text">
                                  {bnk?.companyName}
                                </p>
                                <p className="select-bank-popup-body-content-label">
                                  {bnk?.productName?.startsWith("Product Name")
                                    ? bnk?.companyNameAbbreviation
                                    : bnk?.productName}
                                </p>
                              </div>
                              {selectedBankIdx !== idx && (
                                <img
                                  src={selectBankCircle}
                                  alt="Checkbox Icon"
                                />
                              )}
                              {selectedBankIdx === idx && (
                                <img
                                  src={selectBankClicked}
                                  alt="Checkbox Icon"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {!showAction && props.action === "link-bank" && (
          <button
            id="select-bank-popup-button"
            onClick={(e) => {
              if (
                e.target.className.includes("startup-button") &&
                e.target.className !== "startup-button"
              ) {
                e.target.className = "startup-button-click";
                props.setPopupContent(
                  <LoadingPopup
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    action={
                      selectedBank?.isBr ? "iniciador-connect" : "blink-connect"
                    }
                    isCustom={true}
                    customTextHeader="Connecting..."
                    customTextFooter={`Creating connection gateway to selected bank`}
                    countryCode={props.countryCode}
                    generalDataProps={props.generalDataProps}
                    selectedBank={selectedBank}
                  />,
                );
                props.setPopupContentPosition("flex-end");
                props.setShowPopup(true);
              } else {
                const buttonElement = document.getElementsByClassName(
                  "startup-button-active",
                );
                if (buttonElement.length > 0) {
                  buttonElement[0].className = "startup-button-click";
                  props.setPopupContent(
                    <LoadingPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setFavouriteClicked={props.setFavouriteClicked}
                      action={
                        selectedBank?.isBr
                          ? "iniciador-connect"
                          : "blink-connect"
                      }
                      isCustom={true}
                      customTextHeader="Connecting..."
                      customTextFooter={`Creating connection gateway to selected bank`}
                      countryCode={props.countryCode}
                      generalDataProps={props.generalDataProps}
                      selectedBank={selectedBank}
                    />,
                  );
                  props.setPopupContentPosition("flex-end");
                  props.setShowPopup(true);
                }
              }
            }}
            className="startup-button"
          >
            <p className="add-funds-popup-a-f-button-text">Proceed</p>
          </button>
        )}

        {!showAction && props.action === "custody-select-bank" && (
          <button
            id="select-bank-popup-button"
            onClick={(e) => {
              if (
                e.target.className.includes("startup-button") &&
                e.target.className !== "startup-button"
              ) {
                e.target.className = "startup-button-click";
                props.setShowPopup(false);
                props.setPopupContent(null);
                props.setPopupContentPosition("center");
                if (props.setFavouriteClicked) {
                  props.setFavouriteClicked(false);
                }
                navigate(
                  `/investments/portfolio/create-secondary?pId=${selectedBank?.id}`,
                );
              } else {
                const buttonElement = document.getElementsByClassName(
                  "startup-button-active",
                );
                if (buttonElement.length > 0) {
                  buttonElement[0].className = "startup-button-click";
                  props.setShowPopup(false);
                  props.setPopupContent(null);
                  props.setPopupContentPosition("center");
                  if (props.setFavouriteClicked) {
                    props.setFavouriteClicked(false);
                  }
                  navigate(
                    `/investments/portfolio/create-secondary?pId=${selectedBank?.id}`,
                  );
                }
              }
            }}
            className="startup-button"
          >
            <p className="add-funds-popup-a-f-button-text">Proceed</p>
          </button>
        )}

        {!showAction && props.action === "pre-add-funds" && (
          <button
            id="select-bank-popup-button"
            onClick={(e) => {
              if (
                e.target.className.includes("startup-button") &&
                e.target.className !== "startup-button"
              ) {
                e.target.className = "startup-button-click";
                props.setPopupContent(
                  <LoadingPopup
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    action="blink-acounts"
                    isCustom={true}
                    customTextHeader="Searching..."
                    customTextFooter={`fetching all linked bank accounts`}
                    custodians={props.custodians}
                    selectedCurrency={props.selectedCurrency}
                    generalDataProps={props.generalDataProps}
                    paymentType={"bank"}
                    bankAccountId={props.bankAccountId}
                    selectedBank={selectedBank}
                    amountInPence={props.amountInPence}
                    amount={props.amount}
                  />,
                );
                props.setPopupContentPosition("flex-end");
                props.setShowPopup(true);
              } else {
                const buttonElement = document.getElementsByClassName(
                  "startup-button-active",
                );
                if (buttonElement.length > 0) {
                  buttonElement[0].className = "startup-button-click";
                  props.setPopupContent(
                    <LoadingPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setFavouriteClicked={props.setFavouriteClicked}
                      action="blink-acounts"
                      isCustom={true}
                      customTextHeader="Searching..."
                      customTextFooter={`fetching all linked bank accounts`}
                      custodians={props.custodians}
                      selectedCurrency={props.selectedCurrency}
                      generalDataProps={props.generalDataProps}
                      paymentType={"bank"}
                      bankAccountId={props.bankAccountId}
                      selectedBank={selectedBank}
                      amountInPence={props.amountInPence}
                      amount={props.amount}
                    />,
                  );
                  props.setPopupContentPosition("flex-end");
                  props.setShowPopup(true);
                }
              }
            }}
            className="startup-button"
          >
            <p className="add-funds-popup-a-f-button-text">Proceed</p>
          </button>
        )}

        {!showAction &&
          props.action === "add-funds" &&
          props.bankList?.length > 0 && (
            <button
              id="select-bank-popup-button"
              onClick={(e) => {
                if (
                  e.target.className.includes("startup-button") &&
                  e.target.className !== "startup-button"
                ) {
                  e.target.className = "startup-button-click";
                  if (selectedBank?.custodyCurrencyType === "moneyhub") {
                    props.setPopupContent(
                      <LoadingPopup
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        setFavouriteClicked={props.setFavouriteClicked}
                        action="moneyhub-payment"
                        isCustom={true}
                        customTextHeader="Initializing..."
                        customTextFooter={`Creating bank payment gateway for ${props.selectedCurrency?.tokenName.replace(
                          "VC",
                          "",
                        )}`}
                        custodians={props.custodians}
                        selectedCurrency={props.selectedCurrency?.tokenName}
                        generalDataProps={props.generalDataProps}
                        paymentType={"bank"}
                        requestPayload={{
                          payer_id: props.bankAccountId,
                          payer_bank_id: selectedBank?.providerId,
                          payer_bank_account_id: selectedBank?.bankAccountId,
                          payer_bank_type: selectedBank?.bankType,
                          payer_bank_connection_id: selectedBank?.connectionId,
                          payer_name: userFirstName,
                          payer_email: userEmail,
                          amount_in_pence: props.amountInPence,
                          context: "Other",
                        }}
                      />,
                    );
                    props.setPopupContentPosition("flex-end");
                    props.setShowPopup(true);
                  } else if (selectedBank?.custodyCurrencyType === "blink") {
                    props.setPopupContent(
                      <LoadingPopup
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        setFavouriteClicked={props.setFavouriteClicked}
                        action="blink-payment"
                        isCustom={true}
                        customTextHeader="Initializing..."
                        customTextFooter={`Creating bank payment gateway for ${props.selectedCurrency?.tokenName.replace(
                          "VC",
                          "",
                        )}`}
                        selectedBank={selectedBank}
                        custodians={props.custodians}
                        selectedCurrency={props.selectedCurrency?.tokenName}
                        generalDataProps={props.generalDataProps}
                        paymentType={"bank"}
                        requestPayload={{
                          provider_id: selectedBank?.providerId,
                          payer_id: selectedBank?.userId,
                          payer_account: selectedBank?.bankAccount,
                          amount: props?.amount,
                          amount_currency_symbol: selectedBank?.currency,
                        }}
                      />,
                    );
                    props.setPopupContentPosition("flex-end");
                    props.setShowPopup(true);
                  }
                } else {
                  const buttonElement = document.getElementsByClassName(
                    "startup-button-active",
                  );
                  if (buttonElement.length > 0) {
                    buttonElement[0].className = "startup-button-click";
                    if (selectedBank?.custodyCurrencyType === "moneyhub") {
                      props.setPopupContent(
                        <LoadingPopup
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          action="moneyhub-payment"
                          isCustom={true}
                          customTextHeader="Initializing..."
                          customTextFooter={`Creating bank payment gateway for ${props.selectedCurrency?.tokenName.replace(
                            "VC",
                            "",
                          )}`}
                          custodians={props.custodians}
                          selectedCurrency={props.selectedCurrency?.tokenName}
                          generalDataProps={props.generalDataProps}
                          paymentType={"bank"}
                          requestPayload={{
                            payer_id: props.bankAccountId,
                            payer_bank_id: selectedBank?.providerId,
                            payer_bank_account_id: selectedBank?.bankAccountId,
                            payer_bank_type: selectedBank?.bankType,
                            payer_bank_connection_id:
                              selectedBank?.connectionId,
                            payer_name: userFirstName,
                            payer_email: userEmail,
                            amount_in_pence: props.amountInPence,
                            context: "Other",
                          }}
                        />,
                      );
                      props.setPopupContentPosition("flex-end");
                      props.setShowPopup(true);
                    } else if (selectedBank?.custodyCurrencyType === "blink") {
                      props.setPopupContent(
                        <LoadingPopup
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          action="blink-payment"
                          isCustom={true}
                          customTextHeader="Initializing..."
                          customTextFooter={`Creating bank payment gateway for ${props.selectedCurrency?.tokenName.replace(
                            "VC",
                            "",
                          )}`}
                          selectedBank={selectedBank}
                          custodians={props.custodians}
                          selectedCurrency={props.selectedCurrency?.tokenName}
                          generalDataProps={props.generalDataProps}
                          paymentType={"bank"}
                          requestPayload={{
                            provider_id: selectedBank?.providerId,
                            payer_id: selectedBank?.userId,
                            payer_account: selectedBank?.bankAccount,
                            amount: props?.amount,
                            amount_currency_symbol: selectedBank?.currency,
                          }}
                        />,
                      );
                      props.setPopupContentPosition("flex-end");
                      props.setShowPopup(true);
                    }
                  }
                }
              }}
              className="startup-button"
            >
              <p className="add-funds-popup-a-f-button-text">Proceed</p>
            </button>
          )}

        {!showAction &&
          props.action === "add-funds" &&
          props.bankList?.length === 0 && (
            <button
              onClick={() => {
                props.setPopupContent(
                  <LinkBankOption
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    showMoneyHub={true}
                    generalDataProps={props.generalDataProps}
                  />,
                );
                props.setPopupContentPosition("flex-end");
                props.setShowPopup(true);
              }}
              className="startup-button-active"
            >
              <p className="add-funds-popup-a-f-button-text">
                Link Bank / Card
              </p>
            </button>
          )}

        {showAction && props.action?.includes("withdraw") && (
          <button
            id="select-bank-popup-button"
            onClick={async (e) => {
              if (
                e.target.className.includes("startup-button") &&
                e.target.className !== "startup-button"
              ) {
                e.target.className = "startup-button-click";
                await props.confirmationFunc(
                  selectedBank,
                  setCustomPopupPosition,
                  setCustomPopupContent,
                  setShowCustomPopup,
                );
              } else {
                const buttonElement = document.getElementsByClassName(
                  "startup-button-active",
                );
                if (buttonElement.length > 0) {
                  buttonElement[0].className = "startup-button-click";

                  await props.confirmationFunc(
                    selectedBank,
                    setCustomPopupPosition,
                    setCustomPopupContent,
                    setShowCustomPopup,
                  );
                }
              }
            }}
            className="startup-button-active"
          >
            <p className="add-funds-popup-a-f-button-text">
              Confirm and withdraw
            </p>
          </button>
        )}

        {!showAction &&
          props.action?.includes("withdraw") &&
          props.bankList?.length === 0 && (
            <button
              onClick={() => {
                props.setPopupContent(
                  <LinkBankOption
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    showMoneyHub={true}
                    generalDataProps={props.generalDataProps}
                  />,
                );
                props.setPopupContentPosition("flex-end");
                props.setShowPopup(true);
              }}
              className="startup-button-active"
            >
              <p className="add-funds-popup-a-f-button-text">
                Link Bank / Card
              </p>
            </button>
          )}

        {!showAction &&
          props.action?.includes("withdraw") &&
          props.bankList?.length > 0 && (
            <button
              id="select-bank-popup-button"
              onClick={(e) => {
                if (
                  e.target.className.includes("startup-button") &&
                  e.target.className !== "startup-button"
                ) {
                  e.target.className = "startup-button-click";
                  setShowAction(true);
                } else {
                  const buttonElement = document.getElementsByClassName(
                    "startup-button-active",
                  );
                  if (buttonElement.length > 0) {
                    buttonElement[0].className = "startup-button-click";
                    setShowAction(true);
                  }
                }
              }}
              className="startup-button"
            >
              <p className="add-funds-popup-a-f-button-text">Proceed</p>
            </button>
          )}
      </div>
    </React.Fragment>
  );
};

export default SelectBank;
